import { render } from "./UserChats.vue?vue&type=template&id=12900e63"
import script from "./UserChats.vue?vue&type=script&lang=js"
export * from "./UserChats.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__